import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @mui
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
import GlobalStylesOne from './globalStyles';
import customShadows from './customShadows';
import componentsOverride from './overrides';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const isLoggedIn = useSelector((state) => state.userState?.isLoggedIn);
  const isActiveAs = useSelector((state) => state.userState?.isActiveAs);

  const themeOptions = useMemo(
    () => ({
      palette: {
        ...palette,
        background: isLoggedIn && isActiveAs === 'Expert' ? {
          ...palette.background,
          default: palette.grey[250],
          neutral: palette.grey[300]
        } : palette.background
      },
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(),
      customShadows: customShadows(),
    }),
    [isLoggedIn, isActiveAs]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStylesOne />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
